import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 342px;
  min-height: 84px;
  background: ${props => props.theme.headerColor};
`;

export const Content = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
`;

export const Buttons = styled.div`
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 3px;
  width: 100%;
  height: 24px;
`

export const CallInProgress = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  background-color: #06AB03;
  z-index: 10;

  strong {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
  }

  span {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
  }

`
